import { Injectable, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Tooltip } from '../models/configurators-2d/tooltip';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  currentId: number = 0;
  currentDatas: any;
  autoClose: boolean;
  isLoading: boolean;
  private _returnValue?: any;
  closeEvents = new EventEmitter<void>();
  private _onClose?: () => void;
  private readonly translateService = inject(TranslateService);

  constructor() {}

  public display(modalId: number, datas: any = null, autoClose: boolean = false, onClose?: () => void) {
    this.currentDatas = datas;
    this.currentId = modalId;
    this.autoClose = autoClose;
    this._onClose = onClose;
    this._returnValue = null;
  }

  /**
   * Affiche une modale d'information générique à partir d'un Tooltip
   */
  public displayInfo(tooltip: Tooltip, nameFr: string, nameEn?: string): void {
    const lang = this.translateService.getBrowserLang();
    this.display(MODAL.GENERIC_INFO, {
      title: lang === 'fr' ? tooltip.titleFr || nameFr : tooltip.titleEn || nameEn || nameFr,
      img: tooltip.img,
      description: lang === 'fr' ? tooltip.descriptionFr : tooltip.descriptionEn,
    });
  }

  public close(returnValue?: any) {
    this.currentId = MODAL.NONE;
    this.currentDatas = null;
    this._returnValue = returnValue;
    this._onClose?.();
    this.closeEvents.emit(null);
  }

  public get returnValue(): any {
    return this._returnValue;
  }
}

export enum MODAL {
  NONE,
  DEBUG_INFOS,
  LOGIN,
  REGISTER,
  PROJECTS,
  SEARCH_CUSTOMER,
  PRICE_INFOS,
  PRODUCTS_LIST,
  PRODUCTS_LIST_V2,
  PRINT_MEDIAS,
  IMAGE_ZOOM,
  LOGOUT,
  CONTACT,
  PROJECT_DELETE,
  PROJECT_DUPLICATE,
  DISCOUNT_MANUAL,
  ORDER_PRODUCTS,
  ORDER_CONFIRM,
  FUNDING_COMPARAISON,
  INSTALLATION_DETAIL,
  INSTALLATION_QUOTE,
  SELECT_STORE,
  CLOSET_DOORS_PERCENTAGE,
  CLOSET_DOORS_ADMINISTRATION_MESSAGE,
  CLOSET_DOORS_STRUCTURE_INFO,
  CLOSET_DOORS_PLINTH_INFO,
  CLOSET_DOORS_QUOTE,
  KEEP_CUSTOMER,
  GENERIC_ERROR,
  GENERIC_ERROR_CUSTOMER,
  ADMINISTRATION_ADMINISTRATOR_CREATE,
  ADMINISTRATION_ADMINISTRATOR_UPDATE,
  ADMINISTRATION_DISCOUNT_DELETE,
  INSPIRATION_TIP,
  DECKING_BOARDS_CLASS_INFO,
  MESSAGE,
  SHOPPING_CART_PRODUCT_DELETE,
  SHOPPING_CART_QUANTITY_UPDATE,
  SHOPPING_CART_INFORMATIONS,
  SHOPPING_CART_SUPPLIER_SENDING,
  SHOPPING_CART_ORDER_NUMBER_EDITION,
  SHOPPING_CART_ADD_ASSISTANCE,
  SHOPPING_CART_CHECK_ORDER,
  SHOPPING_CART_VAT_UPDATE,
  SHOPPING_CART_INSTALLATION_REMINDER,
  FENCE_INFOS_ANGLE_KIT,
  FENCE_INFOS_BASE_PLATE,
  MULTI_VAT_QUOTE,
  APPOINTMENT_LINK,
  KITCHEN_TUNNEL_WORKBENCH_CHOICE,
  WORKBENCH_DETAIL,
  FIDELITY_PAYMENT_QRCODE,
  TODOLIST_TASK,
  VALIDATION_DISCOUNT_CHOICE,
  WARNING_INSPIRATION,
  CUSTOMER_INFO_FORM,
  FIDELITY_ADVERTISMENT,
  KITCHEN_APPLIANCE_GENERIC,
  DISPLAY_BARCODE,
  HELP_TIPS,
  REQUEST_COMPLEMENTARY_PRODUCT,
  GENERIC_CONFIRM,
  FORM_POSE,
  GENERIC_INFO,
  BATHROOM_PRODUCT_SEARCH,
  CARPENTRY_PRODUCT_LIST,
  BASKET_DISCOUNT_SELECTION,
  STRATIFIE_CALCULATOR,
  BASKET_CONFIRMATION,
  CIAM_PROFILE_COMPLETION,
}
